import { io } from "socket.io-client";
export const socket = io("https://backend-qureo-production-fab5.up.railway.app");
